import { API_ROOT } from 'core/config/constants';
import { service } from 'libs/api/typed';

import type { paths as CoreApplication } from 'libs/api/generated/core.application';
import type { paths as CorePublicV1 } from 'libs/api/generated/core.public.v1';
import type { paths as PayrollApplication } from 'libs/api/generated/payroll.application';
import type { paths as PayrollPublicV1 } from 'libs/api/generated/payroll.public.v1';
import type { paths as SignApplication } from 'libs/api/generated/sign.application';
import type { paths as SignPublicV1 } from 'libs/api/generated/sign.public.v1';

// One builder for each document the services publish. A document is a service and a version, or the routes the service keeps for our
// own frontends; the paths in it are the whole address, so a module names the route exactly as the document does.
export const signV1 = service<SignPublicV1>(API_ROOT);
export const sign = service<SignApplication>(API_ROOT);
export const payrollV1 = service<PayrollPublicV1>(API_ROOT);
export const payroll = service<PayrollApplication>(API_ROOT);
export const coreV1 = service<CorePublicV1>(API_ROOT);
export const core = service<CoreApplication>(API_ROOT);
